import type { ReactElement } from 'react';
import { Suspense, lazy } from 'react';
import type { NoteEditorProps } from './NoteEditor';
import { NoteText } from './NoteText';

// Its own chunk: most of a megabyte of editor, fetched by the people who edit.
const NoteEditor = lazy(() => import('./NoteEditor'));

/**
 * A note its reader may change, changed where it is read (see `NoteEditor`).
 * While the editor loads, the same text as plain reading — nothing moves when
 * it arrives.
 */
export function EditableNote(props: NoteEditorProps): ReactElement {
  return (
    <Suspense
      fallback={
        <div className="note-editor">
          <div className="note note-editable" aria-busy="true">
            <NoteText>{props.value ?? ''}</NoteText>
          </div>
        </div>
      }
    >
      <NoteEditor {...props} />
    </Suspense>
  );
}
